export default {
  accessToken: '',
  pushToken: '',
  externalId: null,
  phone: '',
  name: '',
  email: '',
  postalCode: '',
  address: '',
  extra: '',
  creditAmount: '',
  coupon: null,
  addresses: [],
  paymentMethods: [],
  items: [],
  orders: null,
  isInternal: false,
  isLoggedIn: false,
};
